export default {
    key: 'הצלחה',
    Things: 'דברים',
    'Upload Date': 'תאריך העלאה',
    Duration: 'מֶשֶׁך',
    Features: 'תכונות',
    'Edit Image': 'ערוך תמונה',
    Title: 'כותרת',
    Description: 'תיאור',
    'New Image': 'תמונה חדשה',
    Image: 'תמונה',
    Images: 'תמונות',
    Tags: 'תגיות',
    'Save & close': 'שמור וסגור',
    Type: 'סוּג',
    Edit: 'לַעֲרוֹך',
    Delete: 'מחיקה',
    'Go back': 'חזרה',
    'New item': 'פריט חדש',
    Id: 'Id',
    'Upload Image': 'העלאת תמונה',
    'Layouts Timeline': 'ציר זמן של פריסות',
    Date: 'תַאֲרִיך',
    'Back stage': 'בהמתנה',
    Front: 'בפוקוס',
    items: 'פריטים',
    'Navigate: Things': 'ניווט: דברים',
    Orientation: 'נטייה',
    back: 'חזרה',
    front: 'בפוקוס',
    gallery: 'גלריה',
    preview: 'תצוגה מקדימה',
    New: 'הוספה',
    search: 'חיפוש',
};
